import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

export async function submitDemo(payload) {
  const { data } = await api.post("/demo", payload);
  return data;
}

export async function listArticles(lang = "en") {
  const { data } = await api.get(`/knowledge/articles`, { params: { lang } });
  return data;
}

export async function getArticle(slug, lang = "en") {
  const { data } = await api.get(`/knowledge/articles/${slug}`, { params: { lang } });
  return data;
}

export async function searchAll(q, lang = "en") {
  const { data } = await api.get(`/search`, { params: { q, lang } });
  return data;
}

/**
 * Stream Ask BHT AI via SSE (fetch-based to allow POST + streaming).
 * onDelta(text), onDone(), onError(msg), onSession(id)
 */
export async function askBhtAI({ message, sessionId, lang = "en" }, handlers = {}) {
  const controller = new AbortController();
  const res = await fetch(`${API}/ai/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "text/event-stream" },
    body: JSON.stringify({ message, session_id: sessionId || null, lang }),
    signal: controller.signal,
  });

  if (!res.ok || !res.body) {
    handlers.onError && handlers.onError(`HTTP ${res.status}`);
    return { abort: () => controller.abort() };
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  (async () => {
    try {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });

        // Parse SSE events separated by blank lines
        let idx;
        while ((idx = buffer.indexOf("\n\n")) !== -1) {
          const raw = buffer.slice(0, idx);
          buffer = buffer.slice(idx + 2);
          const lines = raw.split("\n");
          let event = "message";
          let data = "";
          for (const line of lines) {
            if (line.startsWith("event:")) event = line.slice(6).trim();
            else if (line.startsWith("data:")) data += line.slice(5).trim();
          }
          if (event === "session") handlers.onSession && handlers.onSession(data);
          else if (event === "citations") {
            try {
              handlers.onCitations && handlers.onCitations(JSON.parse(data));
            } catch {}
          }
          else if (event === "error") handlers.onError && handlers.onError(data);
          else if (event === "done") {
            handlers.onDone && handlers.onDone();
            return;
          } else {
            // Unescape our newlines
            handlers.onDelta && handlers.onDelta(data.replace(/\\n/g, "\n"));
          }
        }
      }
      handlers.onDone && handlers.onDone();
    } catch (err) {
      handlers.onError && handlers.onError(err.message || String(err));
    }
  })();

  return { abort: () => controller.abort() };
}
